const Loading = () => import("../components/Loading");
const vLoading = () => import("../components/Loading/Loading");

export default {
  components: { Loading, vLoading },
  data() {
    return {
      baseUrl: process.env.VUE_APP_API_URL,
      //  baseUrl: "https://api.biodcportal.com",
      filePath: process.env.VUE_APP_API_URL,
      isLoadedTimeOut: 5000,
      notUniversity: "1",
      notMehvar: "1",
      notCompany: "1",
    };
  },
  methods: {
    toast(message, type) {
      if (type) {
        let position = "success" ? "top-left" : "top-center";
        this.$toast[type](message, {
          position: position,
          icon: false,
          closeButton: false,
          timeout: 5000,
        });
      } else {
        this.$toast(message, {
          position: "bottom-right",
          icon: false,
          closeButton: false,
          timeout: 5000,
        });
      }
    },
  },
};
